/**
 * @public
 */
export type CssAspectRatio = 'auto' | `${number}` | `${number}/${number}`;

/**
 * @public
 */
export namespace CssAspectRatio {

    /**
     * @public
     */
    export function isCssAspectRatio(value: unknown): value is CssAspectRatio {
        if (typeof value === 'string') {
            if (value.trim() === '') {
                return false;
            }

            if (value === 'auto') {
                return true;
            }

            const ratioParts = value.split('/');
            if (ratioParts.length === 1) {
                // Check if it's a single number
                return !isNaN(Number(ratioParts[0])) && Number(ratioParts[0]) >= 0;
            }
            if (ratioParts.length === 2) {
                // Check if both parts are numbers
                return !isNaN(Number(ratioParts[0])) && Number(ratioParts[0]) >= 0 && !isNaN(Number(ratioParts[1])) && Number(ratioParts[1]) >= 0;
            }
        }

        return false;
    }

}
